import React from 'react'
import { Button, ButtonProps, CircularProgress } from '@mui/material'

type ButtonPrimaryProps = {
  icon?: React.ReactNode
  loading?: boolean | null
} & ButtonProps

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  children,
  variant,
  loading,
  icon,
  ...props
}) => {
  return (
    <Button
      variant={variant || 'primary'}
      data-test-selector="btn-primary"
      startIcon={
        loading ? <CircularProgress size={18} sx={{ color: '#ffffffff' }} /> : icon
      }
      {...props}
    >
      {children}
    </Button>
  )
}

export default ButtonPrimary
